"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMapper = void 0;
class UserMapper {
    toUser(userResource) {
        return {
            id: userResource.id,
            createdAt: new Date(userResource.attributes.createdAt),
            updatedAt: new Date(userResource.attributes.updatedAt),
            lastLogin: userResource.attributes.lastLogin === null ? null : new Date(userResource.attributes.lastLogin),
            name: userResource.attributes.name,
            email: userResource.attributes.email,
        };
    }
    toUserResource(user) {
        return {
            id: user.id,
            type: 'User',
            attributes: {
                createdAt: user.createdAt.toISOString(),
                updatedAt: user.updatedAt.toISOString(),
                lastLogin: user.lastLogin === null ? null : user.lastLogin.toISOString(),
                name: user.name,
                email: user.email,
            },
        };
    }
    toUserCreation(userCreationResource) {
        return {
            name: userCreationResource.attributes.name,
            email: userCreationResource.attributes.email,
        };
    }
    toUserCreationResource(userCreation) {
        return {
            type: 'User',
            attributes: {
                name: userCreation.name,
                email: userCreation.email,
            },
        };
    }
    toUserUpdate(userUpdateResource) {
        return {
            id: userUpdateResource.id,
            name: userUpdateResource.attributes.name,
            email: userUpdateResource.attributes.email,
        };
    }
    toUserUpdateResource(userUpdate) {
        return {
            id: userUpdate.id,
            type: 'User',
            attributes: {
                name: userUpdate.name,
                email: userUpdate.email,
            },
        };
    }
}
exports.UserMapper = UserMapper;
//# sourceMappingURL=#user-mapper.js.map